import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonToggleCompareFirst(props) {
    const map = useMapContext()
    const {pblType, prjId, sVer} = map.data

    if ('INCREMENT' !== pblType) {
        return null
    }

    const handleClick = async () => {
        if (map.isDiffModeOn) {
            map.diffModeOff()
        }
        else {
            const {bizNodeType, pkid} = map.root.data

            const basMap = (() => {
                const _n = map.nodeProxy(map.root)
                const root = _n.exportTree()
                return JSON.stringify({data: map.data, root})
            })()

            const {dataMap: tarMap} = await runAsync(
                () => http.get('/basmapvers/firstVer', {pkid, prjId, sVer}),
                {action: '读取首次发布版'}
            )

            const {
                basMap: leftJson,
                tarMap: rightJson,
                changeList,
            } = await runAsync(
                () => http.post(
                    '/mapcompare/common/map',
                    {basMap, tarMap, type: bizNodeType}
                ),

                {action: '对比首次发布版'}
            )

            map.diffModeOn(leftJson, rightJson, changeList)
        }
    }

    return (
        <MenuButton
            onClick={handleClick}
            {...props}
        >
            {map.isDiffModeOn ? '关闭' : '开启'}对比初版
        </MenuButton>
    )
}
